import { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useTranslation } from "react-i18next";

import cameraIcon from "../../assets/img/icons/camera.svg";
import removeAssignee from "../../assets/img/icons/remove_assignee.svg";
import { createNotification } from "../../modules/notificationManager";
import { CommonText } from "../../styledComponents/common";
import { RoundImageCross } from "../../styledComponents/createProject";
import {
  CameraIcon,
  DropZoneContainer,
  NoImageContainer,
  UpdateImageHoverDiv,
  UploadImageDiv,
} from "./profileStyles";

const thumbsContainer = {
  width: "80px",
  height: "80px",
  borderRadius: "50%",
  objectFit: "cover",
  objectPosition: "center",
};

const dropZoneCss = {
  width: "80px",
  height: "80px",
  objectFit: "cover",
  objectPosition: "center",
  background: "#fff",
  border: "2px dashed #c2cce1",
  borderRadius: "50%",
};
const dropZoneCssNoBorder = {
  width: "80px",
  height: "80px",
  objectFit: "cover",
  objectPosition: "center",
  background: "#fff",
  border: "none",
  borderRadius: "50%",
};

const ImageUpload = props => {
  const [imageState, setImageState] = useState(null);
  const [filesState, setFilesState] = useState("");
  const [isInvalidFile, setIsInvalidFile] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    handleSave();
  }, [filesState]);

    useEffect(() => {
    if (!props.files) {
      // setImageState(null);
      setFilesState("");
    }
  }, [props.files]);

  const onDrop = (accepted, rejected) => {
    if (rejected && rejected.length > 0) {
      setIsInvalidFile(true);
      createNotification("error", "Wrong image format", 3000);
      return;
    }

    const file = accepted && accepted[0];
    if (!file) return;

    if (file.size > 2048000) {
      setIsInvalidFile(true);
      createNotification("error", "Image max size is 2MB", 3000);
      return;
    }

    setIsInvalidFile(false);
    props.addFile(accepted);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const base64data = reader.result;
      file.base64 = base64data;
      setImageState(base64data);
      setFilesState(file);
    };
  };

  const handleSave = () => {
    const { handleSave } = props;
    if (filesState?.base64) {
      handleSave({ image: filesState.base64 });
    }
  };

  const imageRemove = () => {
    if (props.toggleProfilePicRemoveModal) {
      props.toggleProfilePicRemoveModal();
    }
  };

  return (
    <DropZoneContainer>
      {props.files && (
        <RoundImageCross
          disabled={props.updateIsLoading}
          transformX="-21px"
          size="22px"
          display
          onClick={() => props.handleUserProfileRemove()}
        >
          <img
            src={removeAssignee}
            style={{ width: "100%", height: "100%" }}
            alt="remove"
          />
        </RoundImageCross>
      )}

      <Dropzone
        style={
          filesState.base64 || props.files ? dropZoneCssNoBorder : dropZoneCss
        }
        multiple={false}
        accept="image/*"
        onDrop={(accepted, rejected) => onDrop(accepted, rejected)}
      >
        {({ isDragReject }) => {
          if (isInvalidFile || isDragReject) {
            return (
              <NoImageContainer>
                <CommonText fontSize="10px" margin="0 2px 0 2px">
                  {t("please_submit_valid_file")}
                </CommonText>
              </NoImageContainer>
            );
          }

          if (props.files || filesState?.base64) {
            return (
              <UploadImageDiv>
                <img
                  style={thumbsContainer}
                  src={filesState?.base64 || props.files}
                  alt="profile"
                />
                <UpdateImageHoverDiv>
                  <CameraIcon src={cameraIcon} alt="camera" />
                  <CommonText fontSize="10px" margin="0" color="#fff">
                    Update
                  </CommonText>
                </UpdateImageHoverDiv>
              </UploadImageDiv>
            );
          }

          return (
            <NoImageContainer>
              <CameraIcon src={cameraIcon} alt="camera" />
              <CommonText fontSize="8px" title margin="0">
                {t("select_picture")}
              </CommonText>
              <CommonText fontSize="8px" margin="0">
                {t("or_drag_here")}
              </CommonText>
            </NoImageContainer>
          );
        }}
      </Dropzone>
    </DropZoneContainer>
  );
};

export default ImageUpload;
